import { useState } from 'react'

const useModal = _default => {
    const [isOpen, setValue] = useState(!!_default || false)

    const toggle = () => setValue(!isOpen)

    return { isOpen, toggle }
}

export default useModal
